var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.hasPermission)?_c('div',[_vm._t("default")],2):_c('div',{staticStyle:{"justify-content":"center","display":"flex"}},[(_vm.displayLock)?_c('div',{staticClass:"ma-0"},[_c('feature-locked-notify',{staticClass:"mb-5",attrs:{"lockedCode":_vm.moduleName}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }